<div *ngIf="showResetPasswordComponent; else show_login_component">
  <app-reset-password
    [loginScreenPassword]="formGroup.get('password').value"
  ></app-reset-password>
</div>
<ng-template #show_login_component>
  <div class="center-login" [formGroup]="formGroup">
    <div class="alert_banner" *ngIf="showBanner" >
      <div class="alert-box">
        <img class="bell-icon" src="/assets/images/Bell_icon.svg">
      <!-- <span class="alert_text" > -->
        <span>Permanent J-Code J2782 for IZERVAY: Effective April 1, 2024. Click <a href="/assets/pdf/US-AP-2400078 IZERVAY J-Code Effective Flashcard - Digital.pdf" class="link">here</a> for more information.</span>
       <!-- </span> -->
      </div>
       <img class="cross-icon" src="/assets/images/cross-icon.svg" (click)="closeAlertBanner()">
      </div>
    <div class="login-form-content">
      <div class="main-wrap">
        <div class="support-block">
          <div class="sidebar-module">
            <p class="support-info">24/7 Online Support</p>
            <ul class="banner-content-size">
              <li>
                <img src="/assets/images/tick.png" class="check-mark" />
                Enroll patients online
              </li>
              <li>
                <img src="/assets/images/tick.png" class="check-mark" /> Upload documents
              </li>
              <li>
                <img src="/assets/images/tick.png" class="check-mark" />
                Check patient enrollment statuses
              </li>
              <li>
                <img src="/assets/images/tick.png" class="check-mark" />
                Real-time notifications alerts 
              </li>
              <li>
                <img src="/assets/images/tick.png" class="check-mark" />
                Check plan coverage and see evidence of paid claims
              </li>
            </ul>
          </div>
        </div>

        <div class="login-box">
          <div class="wrap-login100 p-l-85 p-r-85 p-t-55 p-b-55">
            <form class="login100-form validate-form flex-sb flex-w">
              <span class="login100-form-title p-b-32"> Login </span>
              <div class="main-login-wrap">
                <span class="txt1 p-b-11 password-input"> Username </span>
                <div
                  class="wrap-input100 validate-input m-b-36"
                  style="margin-bottom: 0.31rem"
                >
                  <app-form-field
                    [labelName]="'Username'"
                    [controlName]="'email'"
                    [formGroup]="formGroup"
                    [placeholderName]="'Enter your username'"
                    [txtSize]="37"
                    [isLogin]="true"
                    [isMEmailRequired]="chkIsPrimary"
                  ></app-form-field>
                  <span class="focus-input100"></span>
                </div>

                <div
                  class="forgot-username-link"
                  (click)="SendForgetUsernameEvent()"
                >
                  <a
                    class="login-pass"
                    routerLink="/credentials/reset-username"
                    style="color: #ffffff"
                    >Forgot Username?</a
                  >
                </div>

                <span class="txt1 p-b-11 password-input"> Password </span>
                <div class="wrap-input100 validate-input m-b-366">
                  <i *ngIf="showPasswordIcon" class="fa fa-eye eye-icon" aria-hidden="true" (click)="togglePassword()"></i>
                  <i *ngIf="!showPasswordIcon" class="fa fa-eye-slash eye-icon" aria-hidden="true" (click)="togglePassword()"></i>
                  <app-form-field
                    [typeOfInput]="showPasswordIcon ?'text': 'password'"
                    [labelName]="'Password'"
                    [controlName]="'password'"
                    [placeholderName]="'Enter your password'"
                    [formGroup]="formGroup"
                    [txtSize]="37"
                    [isLogin]="true"
                    [maxLength]="14"
                  ></app-form-field>
                  <span class="focus-input100"></span>
                </div>

                <div class="flex-sb-m w-full p-b-48">
                  <div
                    class="forgot-password-link"
                    (click)="SendForgetPasswordEvent()"
                  >
                    <a
                      class="login-pass"
                      routerLink="/credentials/reset-password"
                      style="color: #ffffff"
                      >Forgot Password?</a
                    >
                  </div>
                </div>

                <div class="container-login100-form-btn">
                  <button
                    id="btnLogin"
                    class="login100-form-btn landing-login-btn"
                    [ngClass]="{ disabled: !formGroup.valid }"
                    [disabled]="!formGroup.valid"
                    (click)="submitLogin()"
                  >
                    Login
                  </button>
                </div>
              </div>
            </form>
            <div class="links-bottom modal-register">
              <span class="reg-now"> Not Registered? &nbsp; </span>
              <a
                routerLink="/registration"
                class="reg-btn"
                (click)="SendRegisterUserEvent()"
                >Create Account</a
              >
            </div>
          </div>
        </div>        
      </div>
    </div>
  </div>
</ng-template>